import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Footnote from '../Footnote';
import WellnessSoftware from './WellnessSoftware';
import DentalPracticeInfo from './DentalPracticeInfo';
import BuyNumber from './BuyNumber';
import MigrateToWeave from './MigrateToWeave';
import UpdateWeave from './UpdateWeave';

import BookingSoftwares, { OTHER } from '../../assets/AuthBookingSoftwares';
import { DENTAL } from '../../assets/Domains';
import utils from '../../lib/utils';

import './index.scss';

const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];

export default class BusinessProfileSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBuyNumber: false,
      showMigrateToWeave: false,
      showUpdateWeave: false,
    };
    this.handleBuyModal = this.handleBuyModal.bind(this);
    this.closeBuyModal = this.closeBuyModal.bind(this);
    this.handleMigrateModal = this.handleMigrateModal.bind(this);
    this.closeMigrateModal = this.closeMigrateModal.bind(this);
    this.handleWeaveModal = this.handleWeaveModal.bind(this);
    this.closeWeaveModal = this.closeWeaveModal.bind(this);
    this.IsWeaveConfigComplete = this.IsWeaveConfigComplete.bind(this);
  }

  componentDidMount() {
    // Fetch business info
    this.props.getBusiness();
    this.props.canMigrateToWeave();
    // Get profile completion status
    this.props.getTasksStatus();
    // Get setup info
    this.props.getSetupInfo();
  }

  handleBuyModal() {
    this.setState({
      showBuyNumber: true,
    });
  }

  closeBuyModal() {
    this.setState({
      showBuyNumber: false,
    });
    this.props.clearErrorMessage();
  }

  handleMigrateModal() {
    this.setState({
      showMigrateToWeave: true,
    });
  }

  closeMigrateModal() {
    this.setState({
      showMigrateToWeave: false,
    });
    this.props.clearErrorMessage();
  }

  handleWeaveModal() {
    this.setState({
      showUpdateWeave: true,
    });
  }

  closeWeaveModal() {
    this.setState({
      showUpdateWeave: false,
    });
    this.props.clearErrorMessage();
  }

  IsWeaveConfigComplete() {
    const { softwares } = this.props;
    const info = softwares?.info;
    const phoneNumber = info?.weave_phones?.[0]?.id ?? '';
    const externalId = info?.external_id ?? '';
    console.log('IsWeaveConfigComplete', phoneNumber, externalId);
    return Boolean(phoneNumber && externalId);
  }

  render() {
    const {
      business,
      currentDomain,
      carriers,
      softwares,
      dashboard,
      onMindBodyEditClick,
      auth,
    } = this.props;
    const { showBuyNumber, showMigrateToWeave, showUpdateWeave } = this.state;
    const { features } = auth;
    const { weaveInfo, eligible_for_fusion_migration } = carriers;
    const phone_number = carriers?.newPhoneNumber || carriers.phoneNumber;
    const frontdeskTextNumber = utils.hyphenatePhone(phone_number);
    const isCsLogin = csroles.includes(auth?.role);
    const isCsAdmin = auth?.role === 'CS_ADMIN';
    const phoneList = Object.keys(business.phoneList).map((key) => {
      return business.phoneList[key];
    });

    const { selectedSoftware } = softwares;
    const bookingSoftware = BookingSoftwares[selectedSoftware] || {
      label: selectedSoftware,
      value: OTHER,
    };

    let swSetupStatus;
    if (softwares.status === 'verify_failed') {
      swSetupStatus =
        'We were unable to verify your credentials to access your booking software, please enter correct information and submit again';
    } else if (softwares.status === 'verify_success') {
      swSetupStatus = 'Booking software details verified';
    } else if (softwares.status === 'pending_verification') {
      swSetupStatus =
        "We're verifying that we're able to use your booking software. You'll hear from us shortly";
    } else {
      swSetupStatus =
        currentDomain === DENTAL
          ? 'Enter information about your practice'
          : 'Enter information about your booking software';
    }

    // Software load status
    let isSummaryLoaded = false;
    if (softwares?.info?.isLoaded && dashboard?.getsetupInfo) {
      isSummaryLoaded = true;
    }
    const info = softwares?.info;
    const phoneNumber = info?.weave_phones?.[0]?.id ?? '';
    const externalId = info?.external_id ?? '';
    const isWeaveLocation = this.IsWeaveConfigComplete();
    console.log('softwares', weaveInfo);
    return (
      <div className="profile-summary basic-setup">
        <div className="basic-setup__card">
          <div className="card">
            <div className="card__header">
              <span className="card__header__text">Setup Status</span>
            </div>
            <div className="card__content">
              {isSummaryLoaded ? (
                <div className="profile-summary__content">
                  {currentDomain === DENTAL ? (
                    <DentalPracticeInfo
                      softwares={softwares}
                      auth={auth}
                      swSetupStatus={swSetupStatus}
                      onMindBodyEditClick={onMindBodyEditClick}
                    />
                  ) : (
                    <WellnessSoftware
                      bookingSoftware={bookingSoftware}
                      dashboard={dashboard}
                      softwares={softwares}
                      auth={auth}
                      swSetupStatus={swSetupStatus}
                      onMindBodyEditClick={onMindBodyEditClick}
                    />
                  )}

                  {softwares?.is_truelark ?
                    (<div className="summary-item">
                      <div className="summary-item__detail">
                        <div className="summary-item__heading">Phone</div>
                        <div className="phone-number">
                          <div className="summary-item__value">
                            Your TrueLark text-only number:
                          </div>
                          <div className="summary-item__value summary-item__value--big">
                            {frontdeskTextNumber || (
                              <span className="message-welcome">
                                Not yet assigned
                              </span>
                            )}
                          </div>
                        </div>
                        {softwares?.is_truelark && isCsLogin &&
                          <div className="buy-phone-number">
                            <button className="btn btn--primary btn--sm" onClick={this.handleBuyModal}>
                              Buy a new number
                            </button>
                            {showBuyNumber && <BuyNumber modelopen={showBuyNumber} closeBuyModal={this.closeBuyModal} {...this.props} />}
                          </div>}
                        {this.props.dashboard?.setupInfo?.last_call_timeStamp ? (
                          <>
                            <div className="phone-number">
                              <div className="summary-item__value summary-item__value--medium">
                                Last call received :
                              </div>
                              <div className="summary-item__value summary-item__value--medium">
                                {moment(
                                  this.props.dashboard.setupInfo
                                    ?.last_call_timeStamp,
                                ).format('Do MMM YYYY, hh:mm a')}
                              </div>
                            </div>
                            {this.props.dashboard.setupInfo?.forwarded_from ? (
                              <div className="phone-number">
                                <div className="summary-item__value summary-item__value--medium">
                                  Forwarded from :
                                </div>
                                <div className="summary-item__value summary-item__value--medium">
                                  {this.props.dashboard.setupInfo?.forwarded_from}
                                </div>
                              </div>
                            ) : (
                              <div className="phone-number">
                                <div className="summary-item__value summary-item__value--medium">
                                  Direct Call
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="summary-item__value summary-item__value--medium">
                            No calls received on this number.
                          </div>
                        )}
                        {isCsAdmin && eligible_for_fusion_migration &&
                          <div className="migrate-to-weave">
                            <div className="buy-phone-number">
                              <button className="btn btn--primary btn--sm" onClick={this.handleMigrateModal}>
                                Migrate to Weave
                              </button>
                              {showMigrateToWeave && <MigrateToWeave modelopen={showMigrateToWeave} closeBuyModal={this.closeMigrateModal} {...this.props} />}
                            </div>
                            <div className="migrate-to-weave_title">This will enable messaging via Weave</div>
                          </div>}
                        {this.props.dashboard?.setupInfo?.outreach_number && (
                          <>
                            <div className="phone-number margin-above">
                              <div className="summary-item__value">
                                Your Truelark Outreach number :
                              </div>
                              <div className="summary-item__value summary-item__value--big">
                                {utils.hyphenatePhone(
                                  this.props.dashboard.setupInfo.outreach_number,
                                )}
                              </div>
                            </div>
                            {this.props.dashboard.setupInfo.last_outreach_sent ? (
                              <div className="phone-number">
                                <div className="summary-item__value summary-item__value--medium">
                                  Last outreach sent :
                                </div>
                                <div className="summary-item__value summary-item__value--medium">
                                  {moment(
                                    this.props.dashboard.setupInfo
                                      .last_outreach_sent,
                                  ).format('Do MMM YYYY, hh:mm a')}
                                </div>
                              </div>
                            ) : (
                              <div className="summary-item__value summary-item__value--medium">
                                No message sent.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>) :
                    (<><div className="summary-item">
                      <div className="summary-item__detail">
                        <div className="summary-item__heading">Weave</div>
                        <div className="phone-number">
                          <div className="summary-item__value">
                            Weave Location ID:
                          </div>
                          <div className="summary-item__value summary-item__value--big">
                            {(weaveInfo?.external_id || externalId) || (
                              <span className="message-welcome">
                                Not yet configured
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="phone-number">
                          <div className="summary-item__value">
                            Weave AI Assistant Phone Number:
                          </div>
                          <div className="summary-item__value summary-item__value--big">
                            {(weaveInfo?.assignedPhone || frontdeskTextNumber) || (
                              <span className="message-welcome">
                                Not yet configured
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                      <div>
                        {isCsLogin &&
                          <div className="buy-phone-number">
                            <button className="btn btn--primary btn--sm" onClick={this.handleWeaveModal}>
                              Update
                            </button>
                            {showUpdateWeave && <UpdateWeave modelopen={showUpdateWeave} phoneNumber={weaveInfo?.assignedPhone || frontdeskTextNumber} externalId={weaveInfo?.external_id || externalId} closeBuyModal={this.closeWeaveModal} {...this.props} />}
                          </div>}
                      </div></>
                    )}
                </div>
              ) : (
                <div className="text-loader">
                  <p>Loading...</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footnote />
      </div>
    );
  }
}

BusinessProfileSummary.defaultProps = {
  onMindBodyEditClick: () => { },
  onPhoneEditClick: () => { },
  getBusiness: () => { },
  getTasksStatus: () => { },
  currentDomain: '',
  getSetupInfo: () => { },
};

BusinessProfileSummary.propTypes = {
  onMindBodyEditClick: PropTypes.func,
  onPhoneEditClick: PropTypes.func,
  getBusiness: PropTypes.func,
  getTasksStatus: PropTypes.func,
  getSetupInfo: PropTypes.func,
  business: PropTypes.shape({
    phoneList: PropTypes.shape(),
    info: PropTypes.shape({
      BUSINESS_NAME: PropTypes.string,
      TIMEZONE: PropTypes.string,
    }),
    status: PropTypes.shape({
      isSetup: PropTypes.bool,
    }),
  }).isRequired,
  softwares: PropTypes.shape({
    status: PropTypes.string,
    isApproved: PropTypes.bool,
    selectedSoftware: PropTypes.string,
    studioId: PropTypes.string,
    bookerClientId: PropTypes.string,
    otherUsername: PropTypes.string,
    info: PropTypes.shape({
      STUDIO_LOCATION: PropTypes.string,
      STUDIO_NAME: PropTypes.string,
      isLoaded: PropTypes.bool,
    }),
  }).isRequired,
  carriers: PropTypes.shape({
    phoneNumber: PropTypes.string,
  }).isRequired,
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      call_forwarding: PropTypes.string,
      bookingSW_connect: PropTypes.string,
    }),
    setupInfo: PropTypes.shape({
      last_call_timeStamp: PropTypes.string,
      forwarded_from: PropTypes.string,
      outreach_number: PropTypes.string,
      last_outreach_sent: PropTypes.string,
    }),
  }).isRequired,
  currentDomain: PropTypes.string,
};
